import { CellComponentProps } from '@melements/front-components/dist/components/list/table/body/cell/Cell.types';
import { LocaleContext, NotificationsContext, NotificationTypes } from '@melements/front-components/dist/context';
import React, { useContext } from 'react';
import { Button } from 'shared';

import { getErrorMessage } from '../../../../../utils/getErrorMessage/getErrorMessage';
import { ActionButtonWrapper } from '../../../Dashboard.styles';

import { UnlockButtonProps } from './UnlockButton.types';

export const UnlockButton = ({
  onDeleteBlockade,
  data,
  value: callback,
}: CellComponentProps<any> & UnlockButtonProps) => {
  const notificationsContext = useContext(NotificationsContext);
  const localeContext = useContext(LocaleContext);

  const unlockEndpoint = () => {
    onDeleteBlockade(data.id)
      .then(results => {
        if (results.error) {
          showNotificationError(results.error);
        } else {
          showNotificationSuccess();
          callback();
        }
      })
      .catch(error => {
        showNotificationError(error);
      });
  };

  const showNotificationSuccess = () => {
    notificationsContext.showNotification({
      message: localeContext.formatMessage({ id: 'ENDPOINTS.TABLE.ACTION.UNLOCK-SUCCESS' }),
      time: 3000,
      type: NotificationTypes.SUCCESS,
    });
  };

  const showNotificationError = (error: any) => {
    notificationsContext.showNotification({
      message: getErrorMessage(error, localeContext),
      time: 0,
      type: NotificationTypes.ERROR,
    });
  };

  return (
    <ActionButtonWrapper>
      <Button type="leading" className="button--action" onClick={unlockEndpoint}>
        {localeContext.formatMessage({ id: 'ENDPOINTS.TABLE.ACTION.UNLOCK' })}
      </Button>
    </ActionButtonWrapper>
  );
};
